// types
import {
	TraceabilityTransactions,
	TraceabilityTransaction,
	TraceabilityType,
} from '../../../@types';

// i18n
import { t } from 'i18next';

// mui
import { Chip, ChipProps, Tooltip } from '@mui/material';

// utils
import { formatNumber } from '../../../utils/format';

// props
export interface ChipTraceabilityProps {
	traceability: TraceabilityTransactions | TraceabilityTransaction;
	type?: TraceabilityType;
}

export const ChipTraceability = ({
	traceability,
	type = 'TRANSACTIONS',
}: ChipTraceabilityProps) => {
	// vars
	const isTransactions = type === 'TRANSACTIONS' && traceability && 'documentation' in traceability;
	const isFinancial = type === 'FINANCIAL' && traceability && 'financial' in traceability;

	let color: ChipProps['color'] = 'default';
	let documents: TraceabilityTransaction['documents'] | undefined;
	let value = 0;

	if (traceability) {
		documents = (traceability as TraceabilityTransaction).documents;

		let traceabilityValue = null;

		if ('value' in traceability) {
			traceabilityValue = traceability.value;
		} else if (isTransactions) {
			traceabilityValue = traceability.documentation.value;
		} else if (isFinancial) {
			traceabilityValue = traceability.financial.value;
		}

		if (typeof traceabilityValue === 'number') {
			value = traceabilityValue;

			if (traceabilityValue <= 49) {
				color = 'error';
			} else if (traceabilityValue >= 50 && traceabilityValue <= 70) {
				color = 'warning';
			} else if (traceabilityValue >= 71) {
				color = 'success';
			}
		}
	}

	const chip = (
		<Chip color={color} label={`${Math.round(value)}%`} size="small" variant="twoTone" />
	);

	if (isTransactions) {
		return (
			<Tooltip
				arrow={true}
				placement="top"
				title={t('traceabilityUndocumented', {
					undocumented: traceability.documentation.undocumented,
				})}>
				{chip}
			</Tooltip>
		);
	} else if (isFinancial) {
		return (
			<Tooltip
				arrow={true}
				placement="top"
				title={t('partiallyDocumented', {
					denominator: formatNumber(Number(traceability.financial.total || 0), {
						notation: 'compact',
					}),
					numerator: formatNumber(Number(traceability.financial.documented || 0), {
						notation: 'compact',
					}),
				})}>
				{chip}
			</Tooltip>
		);
	} else if (documents) {
		return (
			<Tooltip
				arrow={true}
				placement="top"
				title={t('traceabilityDocuments', {
					required: documents.required.length,
					uploaded: documents.uploaded.length,
				})}>
				{chip}
			</Tooltip>
		);
	}

	return chip;
};
